

export const frontMatter = {};
export const contentTitle = 'Tabs';
export {default as metadata} from '@site/.docusaurus/docusaurus-plugin-content-docs/default/site-docs-components-tabs-mdx-375.json'
export const assets = {

};

import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {RefToIntellijPlatform} from "@site/src/components/RefToIntellijPlatform.tsx";
import {EditorTheme, DebuggerTheme, ToolWindowTheme} from "@intellij-platform/core/Tabs/3-TabThemes.stories";
import {Overflow} from "@intellij-platform/core/Tabs/2-Tabs.stories";
import {Example} from "@site/src/components/ExampleContext";
export const toc = [{
  "value": "Features",
  "id": "features",
  "level": 3
}, {
  "value": "Remaining",
  "id": "remaining",
  "level": 4
}, {
  "value": "Simple usage",
  "id": "simple-usage",
  "level": 2
}, {
  "value": "Overflow behavior",
  "id": "overflow-behavior",
  "level": 2
}, {
  "value": "Customization",
  "id": "customization",
  "level": 2
}, {
  "value": "Editor Theme",
  "id": "editor-theme",
  "level": 3
}, {
  "value": "Debugger Theme",
  "id": "debugger-theme",
  "level": 3
}, {
  "value": "Tool Window Theme",
  "id": "tool-window-theme",
  "level": 3
}];
function _createMdxContent(props) {
  const _components = {
    admonition: "admonition",
    code: "code",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    header: "header",
    input: "input",
    li: "li",
    p: "p",
    pre: "pre",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  if (!DebuggerTheme) _missingMdxReference("DebuggerTheme", false);
  if (!DebuggerTheme.render) _missingMdxReference("DebuggerTheme.render", true);
  if (!EditorTheme) _missingMdxReference("EditorTheme", false);
  if (!EditorTheme.render) _missingMdxReference("EditorTheme.render", true);
  if (!Overflow) _missingMdxReference("Overflow", false);
  if (!Overflow.render) _missingMdxReference("Overflow.render", true);
  if (!ToolWindowTheme) _missingMdxReference("ToolWindowTheme", false);
  if (!ToolWindowTheme.render) _missingMdxReference("ToolWindowTheme.render", true);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.header, {
      children: _jsx(_components.h1, {
        id: "tabs",
        children: "Tabs"
      })
    }), "\n", _jsx(_components.h3, {
      id: "features",
      children: "Features"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "Fully customizable and themeable"
      }), "\n", _jsx(_components.li, {
        children: "Support for different ways of handling overflow"
      }), "\n", _jsx(_components.li, {
        children: "Default tab themes, with support for icon, close button and pinned tabs."
      }), "\n"]
    }), "\n", _jsx(_components.h4, {
      id: "remaining",
      children: "Remaining"
    }), "\n", _jsxs(_components.ul, {
      className: "contains-task-list",
      children: ["\n", _jsxs(_components.li, {
        className: "task-list-item",
        children: [_jsx(_components.input, {
          type: "checkbox",
          disabled: true
        }), " ", "drag and drop"]
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "simple-usage",
      children: "Simple usage"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        metastring: "live",
        live: true,
        children: "<Tabs>\n  <Item>Tab 1</Item>\n  <Item>Tab 2</Item>\n  <Item>Tab 3</Item>\n</Tabs>\n"
      })
    }), "\n", _jsx(_components.h2, {
      id: "overflow-behavior",
      children: "Overflow behavior"
    }), "\n", _jsx(_components.p, {
      children: "There are a few was of handling the overflow, when there is not enough space for showing all tabs. By default tabs will\nscroll horizontally and a small arrow down icon button is added next to the tabs which opens an overflow menu for the\ntabs that are not fully visible, based on the current scroll position."
    }), "\n", _jsx(_components.admonition, {
      type: "tip",
      children: _jsxs(_components.p, {
        children: ["Use ", _jsx(_components.code, {
          children: "TabItem"
        }), " instead of ", _jsx(_components.code, {
          children: "Item"
        }), " to specify via ", _jsx(_components.code, {
          children: "inOverflowMenu"
        }), " prop, a different react node to be shown when the tab\nis rendered in the overflow menu."]
      })
    }), "\n", _jsx(Example, {
      children: _jsx(Overflow.render, {
        maxWidth: 1800
      })
    }), "\n", _jsx("br", {}), "\n", _jsxs(_components.p, {
      children: ["Overflow menu can be disabled via ", _jsx(_components.code, {
        children: "noOverflow"
      }), " prop:"]
    }), "\n", _jsx(Example, {
      children: _jsx(Overflow.render, {
        maxWidth: 1800,
        noOverflowMenu: true
      })
    }), "\n", _jsx("br", {}), "\n", _jsxs(_components.p, {
      children: ["Horizontal scroll can be disabled via ", _jsx(_components.code, {
        children: "noScroll"
      }), " prop. If overflow is also disabled, tabs will be shrunk to fit\nthe available space."]
    }), "\n", _jsx(_components.admonition, {
      type: "warning",
      children: _jsxs(_components.p, {
        children: ["Support for ", _jsx(_components.code, {
          children: "noScroll"
        }), " is under development."]
      })
    }), "\n", _jsx(_components.h2, {
      id: "customization",
      children: "Customization"
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.code, {
        children: "Tabs"
      }), " component allows for ", _jsx(_components.code, {
        children: "TabsComponent"
      }), " (the container) and ", _jsx(_components.code, {
        children: "TabComponent"
      }), " to allow for customizing look and feel.\nBy default ", _jsx(_components.code, {
        children: "StyledDefaultTabs"
      }), " and ", _jsx(_components.code, {
        children: "StyledDefaultTab"
      }), " are used. The following variations are a thin wrapper around\n", _jsx(_components.code, {
        children: "Tabs"
      }), ", which use those two props. They also expose a customized version of ", _jsx(_components.code, {
        children: "TabContentLayout"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "editor-theme",
      children: "Editor Theme"
    }), "\n", _jsxs(_components.p, {
      children: ["Use ", _jsx(_components.code, {
        children: "EditorTabs"
      }), " together with ", _jsx(_components.code, {
        children: "EditorTabContent"
      }), " for editor tab style."]
    }), "\n", _jsx(Example, {
      children: _jsx(EditorTheme.render, {})
    }), "\n", _jsx(_components.h3, {
      id: "debugger-theme",
      children: "Debugger Theme"
    }), "\n", _jsxs(_components.p, {
      children: ["Use ", _jsx(_components.code, {
        children: "DebuggerTabs"
      }), " together with ", _jsx(_components.code, {
        children: "DebuggerTabContent"
      }), " for editor tab style."]
    }), "\n", _jsx(Example, {
      children: _jsx(DebuggerTheme.render, {})
    }), "\n", _jsx(_components.h3, {
      id: "tool-window-theme",
      children: "Tool Window Theme"
    }), "\n", _jsxs(_components.p, {
      children: ["Use ", _jsx(_components.code, {
        children: "ToolWindowTabs"
      }), " together with the default ", _jsx(_components.code, {
        children: "TabContentLayout"
      }), " for editor tab style."]
    }), "\n", _jsx(Example, {
      children: _jsx(ToolWindowTheme.render, {})
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}

